const api_url = "https://clairity-api-mu2v7u3zzq-uc.a.run.app/clairity";

export default api_url;